(function (app) {
    app.provider("surveys", [function () {
        this.$get = ["eligibilityFormApi", function (eligibilityFormApi) {
            var service = {};

            return eligibilityFormApi.getSurveys().then(function (response) {
                response.forEach(function (survey) {
                    survey.SurveyName = survey.SurveyName.replace(/[\s'()]+/g, "");

                    survey.SurveyName.match(/^([A-Z]*)[A-Z]/);

                    if (RegExp.$1.length)
                        survey.SurveyName = survey.SurveyName.replace(RegExp.$1, RegExp.$1.toLowerCase());
                    else
                        survey.SurveyName =
                            survey.SurveyName.charAt(0).toLowerCase() + survey.SurveyName.slice(1);

                    service[survey.SurveyName + "Id"] = survey.SurveyId;
                });

                return service;
            });
        }];
    }]);
})(window.app); // jshint ignore:line